import React from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../common/Hero';
import Footer from '../common/Footer';

const DonationCancel = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        title="Donation Cancelled"
        breadcrumbs={[
          { text: 'Home', link: '/' },
          { text: 'Donate', link: '/donate' },
          { text: 'Cancelled' },
        ]}
      />

      <div className="container my-5">
        <div className="card shadow">
          <div className="card-body text-center p-5">
            <div className="text-danger mb-4">
              <i className="fas fa-times-circle fa-5x"></i>
            </div>
            <h2>Donation Cancelled</h2>
            <p className="lead mb-4">
              Your donation was not completed. You can try again whenever you're ready.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <button className="btn btn-primary" onClick={() => navigate('/donate')}>
                <i className="fas fa-undo me-2"></i> Try Again
              </button>
              <button className="btn btn-outline-secondary" onClick={() => navigate('/')}>
                <i className="fas fa-home me-2"></i> Return Home
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DonationCancel;